"use strict";
exports.__esModule = true;
exports.CONFIRM_PIN = void 0;
exports.CONFIRM_PIN = {
    HEADING: 'Verify your number',
    BODY_1: 'We sent a code to ',
    BODY_2: 'The code will be valid for 10 minutes.',
    CODE_LABEL: 'Verification code',
    SEND_CODE_CTA: 'Send a new code'
};
